import { ServiceContext } from 'utilities/service.utils';

const MapDataService = new ServiceContext(
  process.env.REACT_APP_MAP_DATA_SERVICE_URL,
  {}
);

export default MapDataService;
